import React from 'react';
// @todo: Migrate to 'Link' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {Link} from 'react-router-dom';

import * as Urls from '../../util/urls';

type ReportPageFooterProps = {
  projectName?: string;
};

export const ReportPageFooter = ({projectName}: ReportPageFooterProps) => {
  return (
    <>
      {projectName == null && (
        <div className="report-gallery-text hide-on-print">
          Published with{' '}
          <span className="heart" role="img" aria-label="heart">
            ❤️
          </span>{' '}
          on Weights &amp; Biases. Read more reports in our community,{' '}
          <Link to={Urls.reportGallery()}>Fully Connected</Link>.
        </div>
      )}
      <div className="show-on-print report-created-footer">
        <p>
          Created with{' '}
          <span className="heart" role="img" aria-label="heart">
            ❤️
          </span>{' '}
          on Weights &amp; Biases.
        </p>
        {/* eslint-disable-next-line wandb/no-a-tags */}
        <a href={document.location.href}>{document.location.href}</a>
      </div>
    </>
  );
};
